import { render, staticRenderFns } from "./DepositAndStabilitySection.vue?vue&type=template&id=139f5451&scoped=true"
import script from "./DepositAndStabilitySection.vue?vue&type=script&lang=js"
export * from "./DepositAndStabilitySection.vue?vue&type=script&lang=js"
import style0 from "./DepositAndStabilitySection.vue?vue&type=style&index=0&id=139f5451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139f5451",
  null
  
)

export default component.exports